import styled from 'styled-components';
import { ApModal } from '@alixpartners/ui-components';

export const StyledModal = styled(ApModal)`
  .ap-modal-content {
    max-width: 560px;
    max-height: 100%;
  }

  .ap-modal-body {
    padding: 40px 32px 32px;
    line-height: 24px;
    display: flex;
    flex-direction: column;
  }

  .ap-modal-footer {
    padding: 8px 32px;
  }
`;
